import { render, staticRenderFns } from "./SearchModule.vue?vue&type=template&id=3f7bdce9"
import script from "./SearchModule.vue?vue&type=script&lang=js"
export * from "./SearchModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports